import React from 'react'
import Select from 'react-select'
import FromRating from './FromRating'
import ToRating from './ToRating'
import PopularMoviePage from './PopularMoviePage'
import PersonFilterAccordian from './PersonFilterAccordian'
import AgeRestrictionsDiv from './AgeRestrictionsDiv'
import SoryBy from './SoryBy'
import SortOrder from './SortOrder'
import GOATMovie from './GOATMovie'
import AdminTag from './AdminTag'
import TfidbTagFilter from './TfidbTagFilter'

const FiltersUIsub = props => {
  const {
    statusType,
    appInfoServiceData,
    selectedGenres,
    changeCategoryGenre,
    selectedOTT,
    changeCategoryOTT,
    selectedOthers,
    CheckBoxClick,
    changeOthers,
    changeCategoryAge,
    agevalue,
    ageRestrictionClear,
    AboutEnTe,
    selectedAbout,
    changeAbout,
    Ratingvalue,
    sortByorder,
    sortOrderReset,
    changeSortOrderBy,
    changeCategoryRating,
    ToRatingvalue,
    validation,
    checkPosterurl,
    checkposterlink,
    checkmovieProducedBy,
    checkproducer,
    movieDirectedBy,
    statemovieDirectedBy,
    checkTrue,
    handlePepularMovie,
    handleGOAT,
    handleoriginalLanguage,
    movieFilterBy,
  } = props
  const OttOptions =
    appInfoServiceData && appInfoServiceData.ottListFilters.filter(ott => ott.label !== 'All')
  return (
    <div>
      <div className='platforms-style '>
        <div className='filterstyle'>
          <label>Genre</label>
          <Select
            isDisabled={statusType === 'draft'}
            options={appInfoServiceData && appInfoServiceData.genreListFilters}
            isMulti
            value={selectedGenres}
            name='genre'
            className='basic-multi-select'
            classNamePrefix='select'
            onChange={selectedOption => changeCategoryGenre(selectedOption)}
          />{' '}
        </div>

        <div className='ottplatform'>
          <label>OTT Platform</label>
          <Select
            isDisabled={statusType === 'draft'}
            options={OttOptions}
            isMulti
            value={selectedOTT}
            name='OTT Platform'
            className='basic-multi-select'
            classNamePrefix='select'
            onChange={selectedOTT => changeCategoryOTT(selectedOTT)}
          />{' '}
        </div>
        <div style={{ width: '12rem' }}>
          <lable style={{ fontFamily: 'bold', fontWeight: '600' }}>Others</lable>
          <Select
            isDisabled={statusType === 'draft'}
            options={appInfoServiceData && appInfoServiceData.otherMovieFilters}
            isMulti
            value={selectedOthers}
            name='genre'
            className='basic-multi-select'
            classNamePrefix='select'
            onChange={selectedOthers => changeOthers(selectedOthers)}
          />
        </div>

        <AgeRestrictionsDiv
          appInfoServiceDat={appInfoServiceData}
          statusType={statusType}
          changeCategoryAge={changeCategoryAge}
          agevalue={agevalue}
          ageRestrictionClear={ageRestrictionClear}
        />
        <div style={{ margin: '9px' }}>
          <lable className='font-weight-bold'>About</lable>
          <Select
            isDisabled={statusType === 'draft'}
            options={AboutEnTe}
            isMulti
            value={selectedAbout}
            name='genre'
            className='basic-multi-select'
            classNamePrefix='select'
            onChange={selectedAbout => changeAbout(selectedAbout)}
          />
        </div>
        <SortOrder
          statusType={statusType}
          sortByorder={sortByorder}
          sortOrderReset={sortOrderReset}
          changeSortOrderBy={changeSortOrderBy}
        />
        <SoryBy
          statusType={statusType}
          sortBy={props.sortBy}
          changeSortByValue={props.changeSortByValue}
          sortByReset={props.sortByReset}
        />
        <div className='movieratingg'>
          <label>Movie Rating</label>
          <div className='d-flex gap-3'>
            <div>
              <label>From Rating</label>

              <FromRating
                dinamicRating={appInfoServiceData && appInfoServiceData.ratings}
                Ratingvalue={Ratingvalue}
                changeCategoryRating={changeCategoryRating}
                statusType={statusType}
              />
            </div>
            <div>
              <label>To Rating</label>

              <ToRating
                dinamicRating={appInfoServiceData && appInfoServiceData.ratings}
                ToRatingvalue={ToRatingvalue}
                changeCategoryRatingTo={props.changeCategoryRatingTo}
                statusType={statusType}
              />
            </div>
          </div>
          <lable style={ToRatingvalue < Ratingvalue ? validation.main : validation.mainBlack}>
            To Rating Must Be Greater Then From Rating
          </lable>
        </div>
      </div>
      <div className='d-flex align-items-center' style={{ marginTop: '16px', gap: '1rem' }}>
        <div className='d-flex flex-column'>
          <div style={{ margin: '9px' }} className='d-flex'>
            <input
              disabled={statusType === 'draft'}
              onChange={checkPosterurl}
              checked={checkposterlink}
              type='checkbox'
            />
            <lable className='font-weight-bold'>Poster URL</lable>
          </div>
        </div>
        <div style={{ margin: '9px' }} className='d-flex'>
          <input
            disabled={statusType === 'draft'}
            onChange={checkmovieProducedBy}
            checked={checkproducer}
            type='checkbox'
          />
          <lable className='font-weight-bold'>movieProducedBy</lable>
        </div>
        <div style={{ margin: '9px' }} className='d-flex'>
          <input
            disabled={statusType === 'draft'}
            onChange={movieDirectedBy}
            checked={statemovieDirectedBy}
            type='checkbox'
          />
          <lable className='font-weight-bold'>movieDirectedBy</lable>
        </div>
        <div className='d-flex flex-column'>
          <div className='form-check checkbox-xl releasedate d-flex'>
            <input
              disabled={statusType === 'draft'}
              onClick={CheckBoxClick}
              type='checkbox'
              id='Released date'
              name='Released date'
              checked={checkTrue}
            />
            <label style={{ display: 'flex', alignItems: 'center' }}>Released date</label>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <TfidbTagFilter
          movieFilterBy={movieFilterBy}
          handleFilterChange={props.handleFilterChange}
          type={'movie'}
        />
        <AdminTag
          movieFilterBy={movieFilterBy}
          handleFilterChange={props.handleFilterChange}
          type={'movie'}
          label={'Good'}
        />
        <AdminTag
          movieFilterBy={movieFilterBy}
          handleFilterChange={props.handleFilterChange}
          type={'movie'}
          label={'Bad'}
        />
      </div>
      <div className='d-flex pt-4 pb-5'>
        <PopularMoviePage
          statusType={statusType}
          checkPopularMovie={props.checkPopularMovie}
          handlePepularMovie={handlePepularMovie}
          sortPopularMoviesReset={props.sortPopularMoviesReset}
        />
        <GOATMovie
          statusType={statusType}
          GOAT={props.GOAT}
          handleGOAT={handleGOAT}
          sortGOATReset={props.sortGOATReset}
          label={'GOAT'}
          DefaultValue={'GOAT'}
        />
        <GOATMovie
          statusType={statusType}
          GOAT={props.originalLanguageTelugu}
          handleGOAT={handleoriginalLanguage}
          sortGOATReset={props.sortoriginalLanguage}
          label={'originalLanguage'}
          DefaultValue={'Telugu'}
        />
      </div>

      <div>
        <PersonFilterAccordian
          // conditionBasedFilterCastORCrew={props.conditionBasedFilterCastORCrew}
          isExpandAll={props.isExpandAll}
          setExpandAll={props.setExpandAll}
          SearchPersonCast={props.SearchPersonCast}
          setSearchPersonCast={props.setSearchPersonCast}
          setSearchPersonProd={props.setSearchPersonProd}
          SearchPersonProd={props.SearchPersonProd}
          setSearchPersonEditor={props.setSearchPersonEditor}
          SearchPersonEditor={props.SearchPersonEditor}
          setSearchPersonCenimato={props.setSearchPersonCenimato}
          SearchPersonCenimato={props.SearchPersonCenimato}
          setSearchPersonMusic={props.setSearchPersonMusic}
          SearchPersonMusic={props.SearchPersonMusic}
          setSearchPersonDialog={props.setSearchPersonDialog}
          SearchPersonDialog={props.SearchPersonDialog}
          SearchPerson={props.SearchPerson}
          setSearchPerson={props.setSearchPerson}
          ResetAccordianData={props.ResetAccordianData}
          PersonCrewFilterData={props.PersonCrewFilterData}
          statusType={statusType}
          selectedCastData={props.selectedCastData}
          setSelectedCastData={props.setSelectedCastData}
          PersonCrewFilter={props.PersonCrewFilter}
          setselectedCrewProd={props.setselectedCrewProd}
          setSelectedCrewDirector={props.setSelectedCrewDirector}
          setselectedCrewEditor={props.setselectedCrewEditor}
          setSelectedCrewDialog={props.setSelectedCrewDialog}
          setselectedCrewMusic={props.setselectedCrewMusic}
          selectedCrewProd={props.selectedCrewProd}
          selectedCrewDirector={props.selectedCrewDirector}
          selectedCrewEditor={props.selectedCrewEditor}
          selectedCrewDialog={props.selectedCrewDialog}
          selectedCrewMusic={props.selectedCrewMusic}
          selectedCrewCenimato={props.selectedCrewCenimato}
          setselectedCrewCenimato={props.setselectedCrewCenimato}
        />
      </div>
    </div>
  )
}

export default FiltersUIsub
